import SocialSharingButtons from './SocialSharingButtons.vue'
import SocialSharingTwitterIcon from './SocialSharingTwitterIcon.vue'
import SocialSharingFacebookIcon from './SocialSharingFacebookIcon.vue'

const toolkitsComponents = [SocialSharingButtons, SocialSharingTwitterIcon, SocialSharingFacebookIcon]

export default toolkitsComponents
